import { APPUSER_ACTIVITIES, ACTIVITY_FORM_RENDER } from '../actions';

export const appuserActivitiesReducer = (state = {}, action) => {
  if (action.type === APPUSER_ACTIVITIES) return action.payload;
  return state;
};

export const getActivityFormReducer = (state = { state: false }, action) => {
  if (action.type === ACTIVITY_FORM_RENDER) return action.payload;
  return state;
};
